import Insight from "../insightClass";
import React from "react";
import { insight26Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight052 = new Insight(
  "27 June 2025",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight26Media[0],
    alt: "offshore wind turbine",
  },
  "Global Offshore Wind Weekly (2025-06-27)",
  "",
  `The UK has rejected Xlinks’ £24 billion proposal to import 3.6 GW of renewable energy—enough to power seven million homes—via a 3,800 km subsea cable from Morocco. Energy Secretary Ed Miliband cited concerns over energy security, deliverability, geopolitics, and costs, preferring domestic clean-energy alternatives.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2025-06-27)</h1>
    <h2></h2>
    <p className="article-date">27 June 2025</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>

    <h3>1. UK Rejects £24 B Morocco–UK Subsea Power Project</h3>
    <p>
      The UK has rejected Xlinks’ £24 billion proposal to import 3.6 GW of
      renewable energy—enough to power seven million homes—via a 3,800 km subsea
      cable from Morocco. Energy Secretary Ed Miliband cited concerns over
      energy security, deliverability, geopolitics, and costs, preferring
      domestic clean-energy alternatives.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      The UK is prioritising energy sovereignty and local supply chains. While
      cross-border megaprojects promise scale, they also introduce complexity,
      geopolitical exposure, and cost uncertainty. Exiting this project reflects
      a strategic shift toward homegrown offshore wind and storage as more
      controllable, scalable solutions.
    </p>
    <h3>2. UK Floating Wind Supply Chain Secures £1 Billion Investment</h3>
    <p>
      The UK government and private sector have pledged £1 billion to boost
      floating wind supply chains. The funds will support manufacturing, port
      upgrades, and subsea cable capacity. Partners include Crown Estate, Great
      British Energy, and leading OEMs.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      This landmark investment demonstrates strong public-private confidence in
      floating wind as the UK’s next frontier. It will unlock critical
      infrastructure, accelerate technology localization, and strengthen the
      UK’s competitiveness as a global hub for floating wind deployment and
      export.
    </p>
    <h3>3. Muir Mhòr Floating Wind Project Secures Onshore Consent</h3>
    <p>
      The 1 GW Muir Mhòr floating wind project in Scotland has received onshore
      planning approval for grid infrastructure. Subject to marine permitting,
      it could power over one million homes and become operational before 2030.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      A key milestone for commercial floating wind in the UK. Muir Mhòr will
      help de-risk floating technology and accelerate deployment in deeper
      waters, reinforcing Scotland’s position as a leader in floating wind
      innovation.
    </p>
    <h3>4. Siemens Gamesa in Talks to Localise Magnet Production in Europe</h3>
    <p>
      Siemens Gamesa is collaborating with Chinese suppliers to establish a
      permanent magnet factory in Europe. The initiative aims to reduce
      dependency on Chinese rare earths and mitigate risks to turbine supply
      chains.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      A clear signal of Europe’s shift toward critical component independence.
      While localisation raises costs, it enhances energy security and aligns
      with EU goals to onshore green industrial supply chains. It also supports
      long-term resilience in wind technology manufacturing.
    </p>
    <h3>5. Norway Identifies Four New Offshore Wind Zones</h3>
    <p>
      Norway has designated four new areas for offshore wind
      development—Frøyabanken, Træna Vest, Nordmela, and Sørlege Nordsjø II
      Phase 2—with up to 3 GW of potential capacity. A public consultation is
      open until September.  
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Norway’s proactive zoning strengthens its role in North Sea offshore
      expansion. It balances clean energy goals with stakeholder concerns such
      as fisheries and biodiversity. These zones will also attract early
      developer interest ahead of formal leasing rounds.
    </p>
    <h3>6. Poland Sets First Offshore Wind Auction Date for December 2025</h3>
    <p>
      Poland has announced its first offshore wind Contracts for Difference
      (CfD) auction will take place on 17 December 2025. The move opens its
      Baltic Sea coast to international developers and investors.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      This auction marks Poland’s entry into Europe’s offshore wind mainstream.
      A transparent CfD structure will draw global bidders and drive new supply
      chain hubs in Central and Eastern Europe, diversifying the EU wind
      landscape.
    </p>
    <h3>7. Japanese Company Joins Spanish Floating Wind Demo</h3>
    <p>
      Japan’s Toda Corporation has joined Spain’s GENAQ floating wind
      demonstration off Gran Canaria. The 2 MW pilot will test a
      semi-submersible platform and explore joint opportunities between Asia and
      Europe in floating wind technology.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Cross-regional partnerships like this demonstrate floating wind’s global
      scalability. Demonstration-scale projects are key to advancing design
      convergence, technology readiness, and early market cooperation across
      continents.
    </p>

    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
